import { render, staticRenderFns } from "./PurchaseOtherPaymentApproved.vue?vue&type=template&id=8ce8725c"
import script from "./PurchaseOtherPaymentApproved.vue?vue&type=script&lang=js"
export * from "./PurchaseOtherPaymentApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports